import resume from "../assets/documents/israel-kayaba-resume.pdf";
import heroPortrait from "../assets/portraits/hero-navy-overshirt.png";
import aboutPortrait from "../assets/portraits/confident-lounge.jpeg";
import experiencePortrait from "../assets/portraits/confident-office.png";
import blogPortrait from "../assets/references/reference-photo-01.jpeg";
import contactPortrait from "../assets/references/reference-photo-02.png";
import { blogPosts } from "./blogPosts";
import { experienceData, skillGroups } from "./experienceData";
import { projectsData } from "./projectsData";
import { servicesData } from "./servicesData";
import { testimonialsData } from "./testimonialsData";

export const portfolioFallback = {
  profile: {
    name: "Israel Kayaba",
    role: { en: "Software & Integration Developer", fr: "Développeur logiciel et intégration" },
    summary: { en: "I turn complex ideas into thoughtful, reliable digital products—combining modern frontend experiences with scalable backend systems.", fr: "Je transforme des idées complexes en produits numériques fiables et bien pensés, en associant des interfaces modernes à des systèmes backend évolutifs." },
    bio: { en: "Software Engineer working across full-stack development, secure API integrations and real-time data platforms. I build enterprise and e-commerce systems with a strong focus on database design, system integration and cloud-enabled delivery.", fr: "Ingénieur logiciel actif dans le développement full-stack, les intégrations d'API sécurisées et les plateformes de données en temps réel. Je construis des systèmes d'entreprise et e-commerce avec une attention particulière à la conception des données, l'intégration et le déploiement cloud." },
    location: "Johannesburg",
    email: "Israelkayaba@gmail.com",
    phone: "+27 64 358 9464",
    resume,
    images: { hero: heroPortrait, about: aboutPortrait, experience: experiencePortrait, blog: blogPortrait, contact: contactPortrait },
    socials: {
      linkedin: "https://www.linkedin.com/in/israel-kayaba-67678a1a8/",
      github: "https://github.com/Izzy-kayaba",
      instagram: "https://www.instagram.com/izzy.kyb/",
      twitter: "https://twitter.com/israel_kayaba"
    }
  },
  aboutStats: [
    { value: `${new Date().getFullYear() - 2021} years`, label: { en: "Professional Experience", fr: "Expérience professionnelle" }, icon: "award" },
    { value: { en: "Full-stack & Integration", fr: "Full-stack et intégration" }, label: { en: "Core focus", fr: "Spécialité" }, icon: "code" },
    { value: { en: "BSc Information Technology", fr: "Licence en technologies de l'information" }, label: { en: "Education", fr: "Formation" }, icon: "education" },
    { value: "Johannesburg", label: { en: "Based in", fr: "Basé à" }, icon: "location" }
  ],
  services: servicesData,
  projects: projectsData(false),
  experience: experienceData,
  skillGroups,
  blogPosts,
  testimonials: testimonialsData,
  contactOptions: [
    { type: "email", label: { en: "Email", fr: "E-mail" }, value: "Israelkayaba@gmail.com", href: "mailto:Israelkayaba@gmail.com" },
    { type: "linkedin", label: { en: "LinkedIn", fr: "LinkedIn" }, value: "Israel Kayaba", href: "https://www.linkedin.com/in/israel-kayaba-67678a1a8/" },
    { type: "whatsapp", label: { en: "WhatsApp", fr: "WhatsApp" }, value: "+27 64 358 9464", href: "https://wa.me/+27643589464" }
  ]
};
